import { useState } from 'react';
import {
    Box,
    FlexBox,
    Icon,
    Link,
    ModalDialog,
    ModalDialogBody,
    ModalDialogCloseButton,
    ModalDialogContent,
    ModalDialogHeader,
    ModalDialogNav,
    ModalDialogTitle,
    Typography,
} from '@vp/swan';
import { __ } from '@99designs/i18n';
import { Price } from '@99designs/pricing';
import { NormalisedBriefProduct } from '../BriefContext';
import { HowItWorks } from '../HowItWorks/HowItWorks';
import { StepProductCard } from './StepProductCard';

export function Information({ product }: { product?: NormalisedBriefProduct | null }) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!product) {
        return null;
    }

    return (
        <>
            <FlexBox
                flexDirection={{ xs: 'column-reverse', sm: 'row' }}
                alignItems={{ xs: 'flex-start', sm: 'center' }}
                mr={{ sm: 5 }}
            >
                <Link
                    skin="standard"
                    marginRight={6}
                    paddingTop={2}
                    onClick={() => setIsModalOpen(!isModalOpen)}
                    withIcon={true}
                >
                    {__("What's included", {
                        _context:
                            "Label for a button that opens a modal with more information about what's included in the product",
                    })}
                    <Icon iconType="info" size="20p" />
                </Link>
                <Typography fontSkin="title-section" textAlign={{ sm: 'left' }}>
                    <Price
                        stacked
                        subtleTaxMessage
                        price={{
                            currency: product.pricing.currency,
                            listPrice: {
                                taxed: product.pricing.taxed,
                                untaxed: product.pricing.untaxed,
                            },
                        }}
                    />
                </Typography>
            </FlexBox>
            <InformationModal product={product} isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
}

interface InformationModalProps {
    product: NormalisedBriefProduct;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

function InformationModal(props: InformationModalProps) {
    return (
        <ModalDialog isOpen={props.isOpen} onRequestDismiss={() => props.setIsOpen(false)}>
            <ModalDialogContent aria-labelledby="modal dialog general" style={{ width: '600px' }}>
                <ModalDialogNav>
                    <ModalDialogCloseButton accessibleText={__('Close')} />
                </ModalDialogNav>
                <ModalDialogHeader>
                    <ModalDialogTitle>{__("What's included")}</ModalDialogTitle>
                </ModalDialogHeader>
                <ModalDialogBody>
                    <StepProductCard product={props.product} />
                    <Box mt={7}>
                        <HowItWorks isModal />
                    </Box>
                </ModalDialogBody>
            </ModalDialogContent>
        </ModalDialog>
    );
}
